import React, { Fragment } from 'react'
import { Header, SubHeader } from 'shared/components/ui/Typography'

import Form from './Form'

export default function CustomerInformationPage() {
  return (
    <Fragment>
      <Header size="medium" as="h1">
        Tell us about yourself
      </Header>
      <SubHeader size="small" as="h2">
        This helps us personalise your app experience
      </SubHeader>
      <Form />
    </Fragment>
  )
}
